import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#6e151e",
    },
    background: {
      default: "#fafafa",
      // paper: "#e4e5f1",
    },
    text: {
      primary: "#000000",
      secondary: "#666666",
    },
  },
  typography: {
    fontFamily: 'Inter, Arial, sans-serif',
    fontSize: 16,
    h1: {
      fontFamily: '"Cormorant Infant", Georgia, "Times New Roman", serif',
      fontSize: "3.375rem",
      fontWeight: 600,
    },
    h2: {
      fontFamily: '"Cormorant Infant", Georgia, "Times New Roman", serif',
      fontSize: "3rem",
      fontWeight: 600,
    },
    h3: {
      fontFamily: '"Cormorant Infant", Georgia, "Times New Roman", serif',
      fontSize: "1.875rem",
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Cormorant Infant", Georgia, "Times New Roman", serif',
      fontSize: "1.5rem",
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"Cormorant Infant", Georgia, "Times New Roman", serif',
      fontSize: "1.25rem",
      fontWeight: 600,
    },
    h6: {
      fontFamily: '"Cormorant Infant", Georgia, "Times New Roman", serif',
      fontSize: "1.125rem",
      fontWeight: 600,
    },
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
    },
    body2: {
      fontSize: "0.875rem",
      fontWeight: 400,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1512,
    },
  },
});

export default theme;
